import {
  useMostAccessedCatalogsSource,
  UseMostAccessedCatalogsSourceParams,
} from './most-accessed-catalogs-source';

export const useMostAccessedCatalogsByDepartmentSource = (
  params: UseMostAccessedCatalogsSourceParams,
  options?: { enabled?: boolean }
) => useMostAccessedCatalogsSource('department', params, options);
